import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import "line-awesome/dist/line-awesome/css/line-awesome.min.css";
import profilee from "assets/img/profilee.webp";
import axios from "axios";

export default function FranchiseDashboard() {

  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    axios
      .get("https://api.juniortoes.com/api/franchises")
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  // Search functionality
  const filteredData = data.filter((row) =>
    Object.values(row).some((val) =>
      val?.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  // Sorting functionality
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const sortedData = React.useMemo(() => {
    if (!sortConfig.key) return filteredData;

    return [...filteredData].sort((a, b) => {
      const aVal = a[sortConfig.key]?.toString().toLowerCase() ?? '';
      const bVal = b[sortConfig.key]?.toString().toLowerCase() ?? '';

      if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [filteredData, sortConfig]);

  // Pagination functionality
  const totalEntries = sortedData.length;
  const totalPages = Math.ceil(totalEntries / entriesPerPage);
  const startEntry = (currentPage - 1) * entriesPerPage;
  const endEntry = Math.min(currentPage * entriesPerPage, totalEntries);
  const paginatedData = sortedData.slice(startEntry, endEntry);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleEntriesChange = (e) => {
    const newEntriesPerPage = parseInt(e.target.value);
    setEntriesPerPage(newEntriesPerPage);
    setCurrentPage(1);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page when searching
  };

  const handleEdit = (index) => {
    alert(`Editing row ${index + 1}`);
  };

  const handleDelete = (index) => {
    const updatedData = data.filter((_, i) => i !== index);
    setData(updatedData);
  };

  // Generate page numbers for pagination
  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  };

  const handleDownload = (type) => {
    const url =
      type === "pdf"
        ? "https://api.juniortoes.com/api/franchise/pdf"
        : "https://api.juniortoes.com/api/franchise/excel";
    
    window.open(url, "_blank");
  };
  return (
    <>
      <div>
        <div className="flex">
          <div className="xl:w-2/12">
            <Sidebar />
          </div>
          <div className="xl:w-12/12">
            <div className="xl:w-12/12 flex justify-end items-center xl:mt-12 gap-8 -ml-16">
              <div className="xl:w-3/12">
                <div className="flex space-x-4">
                  <div className="relative flex w-full h-10 px-4 ">
                    <i className="las la-search absolute left-4 text-gray-400 xl:text-2xl mt-2 pl-2"></i>
                    <input
                      type="text"
                      placeholder="Search for anything here..."
                      className="bg-transparent borderform rounded-full text-gray-500 w-full outline-none pl-10 bg-gray"
                      onChange={handleSearch}
                    />
                  </div>
                  <div>
                    <button className="background-blue text-white w-10 h-10 rounded-full flex items-center justify-center">
                      <i className="las la-plus text-lg"></i>
                    </button>
                  </div>
                </div>
              </div>
              {/* Action Buttons */}
              <div style={{ borderRight: "1px solid grey" }}>
                <div style={{ display: "flex", gap: "1rem" }}>
                  <button
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    <i
                      className="las la-bell"
                      style={{ fontSize: "1.2rem" }}
                    ></i>
                  </button>
                  <button
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    <i className="las la-th" style={{ fontSize: "1.2rem" }}></i>
                  </button>
                  <button
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    <i
                      className="las la-cog mr-8"
                      style={{ fontSize: "1.2rem" }}
                    ></i>
                  </button>
                </div>
              </div>
              {/* User Profile */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "1rem",
                  borderRight: "1px solid grey",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <i className="las la-user" style={{ fontSize: "1.5rem" }}></i>
                  <span className="mr-8">1/4</span>
                </div>
              </div>
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <img
                    src={profilee}
                    alt="User Avatar"
                    style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "50%",
                    }}
                  />
                  <div>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "0.875rem",
                        fontWeight: "500",
                      }}
                    >
                      Darell Steward
                    </p>
                    <p
                      style={{ margin: 0, fontSize: "0.75rem", color: "#888" }}
                    >
                      Super Admin
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <hr className="mt-4" style={{ borderTop: "1px solid grey" }} />
              <div className="mt-8 ml-68">
                <div className="flex justify-end gap-2 mr-12 mt-12 mb-3">
                  <button className="background-blue text-white px-6 py-2 rounded-md" onClick={() => handleDownload("pdf")}>
                    Download PDF
                  </button>
                  <button  className="background-blue text-white px-12 py-2 rounded-md" onClick={() => handleDownload("excel")}>
                    Download Excel
                  </button>
                </div>
                <div className="flex justify-between items-center mb-4">
                  <div className="xl:w-3/12">
                    <div className="relative flex w-full h-10">
                      <i className="las la-search absolute left-4 text-gray-400 text-2xl mt-2 pl-2"></i>
                      <input
                        type="text"
                        placeholder="Search for anything here..."
                        className="bg-transparent borderform rounded-full text-gray-500 w-full outline-none pl-10"
                        onChange={handleSearch}
                        value={searchTerm}
                      />
                    </div>
                  </div>
                  <div className="flex gap-4 mr-12">
                    <div className="flex gap-2">
                      <div className="relative">
                        <select
                          className="px-6 py-2 borderform rounded-md"
                          value={entriesPerPage}
                          onChange={handleEntriesChange}
                        >
                          <option value={10}>10</option>
                          <option value={20}>20</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                        </select>
                      </div>
                      <p className="pt-2">Entries per page </p>
                    </div>
                  </div>
                </div>

                {/* table starts */}
                <div className="p-4">
                  <div className="overflow-x-auto">
                    <table className="table-fixed w-full border-collapse borderform">
                      <thead className="bg-gray-100 sticky top-0">
                        <tr style={{ fontSize: "15px", fontWeight: 100 }}>
                          <th className="borderform px-4 py-2">
                            <input type="checkbox" />
                          </th>
                          <th
                            className="borderform px-4 py-2 cursor-pointer"
                            onClick={() => handleSort("date&time")}
                          >
                            Date&Time
                            {sortConfig.key === "firstName" && (
                              <i
                                className={`ml-2 ${
                                  sortConfig.direction === "asc"
                                    ? "fas fa-chevron-up"
                                    : "fas fa-chevron-down"
                                }`}
                              ></i>
                            )}
                          </th>
                          <th
                            className="borderform px-4 py-2 cursor-pointer"
                            onClick={() => handleSort("firstName")}
                          >
                            Name
                            {sortConfig.key === "firstName" && (
                              <i
                                className={`ml-2 ${
                                  sortConfig.direction === "asc"
                                    ? "fas fa-chevron-up"
                                    : "fas fa-chevron-down"
                                }`}
                              ></i>
                            )}
                          </th>
                          <th
                            className="borderform px-4 py-2 cursor-pointer"
                            onClick={() => handleSort("city")}
                          >
                            City
                            {sortConfig.key === "city" && (
                              <i
                                className={`ml-2 ${
                                  sortConfig.direction === "asc"
                                    ? "fas fa-chevron-up"
                                    : "fas fa-chevron-down"
                                }`}
                              ></i>
                            )}
                          </th>
                          <th
                            className="borderform px-12 py-2 cursor-pointer"
                            onClick={() => handleSort("area")}
                          >
                            Area
                            {sortConfig.key === "area" && (
                              <i
                                className={`ml-2 ${
                                  sortConfig.direction === "asc"
                                    ? "fas fa-chevron-up"
                                    : "fas fa-chevron-down"
                                }`}
                              ></i>
                            )}
                          </th>
                          <th
                            className="borderform px-4 py-2 cursor-pointer"
                            onClick={() => handleSort("investment")}
                          >
                            Investment
                            {sortConfig.key === "investment" && (
                              <i
                                className={`ml-2 ${
                                  sortConfig.direction === "asc"
                                    ? "fas fa-chevron-up"
                                    : "fas fa-chevron-down"
                                }`}
                              ></i>
                            )}
                          </th>
                          <th
                            className="borderform px-4 py-2 cursor-pointer"
                            onClick={() => handleSort("start")}
                          >
                            Start
                            {sortConfig.key === "start" && (
                              <i
                                className={`ml-2 ${
                                  sortConfig.direction === "asc"
                                    ? "fas fa-chevron-up"
                                    : "fas fa-chevron-down"
                                }`}
                              ></i>
                            )}
                          </th>
                          <th
                            className="borderform px-4 py-2 cursor-pointer"
                            onClick={() => handleSort("email")}
                          >
                            Email
                            {sortConfig.key === "email" && (
                              <i
                                className={`ml-2 ${
                                  sortConfig.direction === "asc"
                                    ? "fas fa-chevron-up"
                                    : "fas fa-chevron-down"
                                }`}
                              ></i>
                            )}
                          </th>
                          <th
                            className="borderform px-4 py-2 cursor-pointer"
                            onClick={() => handleSort("phone")}
                          >
                            Phone
                            {sortConfig.key === "phone" && (
                              <i
                                className={`ml-2 ${
                                  sortConfig.direction === "asc"
                                    ? "fas fa-chevron-up"
                                    : "fas fa-chevron-down"
                                }`}
                              ></i>
                            )}
                          </th>
                          <th
                            className="borderform px-4 py-2 cursor-pointer"
                            onClick={() => handleSort("status")}
                          >
                            Status
                            {sortConfig.key === "status" && (
                              <i
                                className={`ml-2 ${
                                  sortConfig.direction === "asc"
                                    ? "fas fa-chevron-up"
                                    : "fas fa-chevron-down"
                                }`}
                              ></i>
                            )}
                          </th>
                          <th className="borderform px-4 py-2">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedData.map((row, index) => (
                          <tr key={index} className="borderform">
                            <td className="borderform px-4 py-2">
                              <input type="checkbox" />
                            </td>
                            <td className="borderform px-2 text-sm py-2 text-left">
                            {row.formatted_created_at}
                            </td>
                            <td className="borderform px-2 text-sm py-2 text-left">
                              {row.name}
                            </td>
                            <td className="borderform px-2 text-sm py-2 text-left">
                              {row.city}
                            </td>
                            <td className="borderform px-2 py-2 text-sm text-left">
                              {row.area}
                            </td>
                            <td className="borderform px-2 py-2 text-sm text-left">
                              {row.investment}
                            </td>
                            <td className="borderform px-2 py-2 text-sm text-left">
                              {row.start}
                            </td>
                            <td className="borderform px-2 py-2 text-sm text-left">
                              {row.email}
                            </td>
                            <td className="borderform px-2 py-2 text-sm text-left">
                              {row.phone}
                            </td>
                            <td className="borderform px-2 py-2 text-sm text-left">
                              {row.status}
                            </td>
                            <td className=" px-2 py-2 text-sm items-center flex">
                              <button
                                className="px-3 py-2 text-sm text-blue rounded-md"
                                onClick={() => handleEdit(index)}
                              >
                                <i className="fas fa-edit"></i>
                              </button>
                              <button
                                className="ml-2 py-2 text-sm text-danger rounded-md"
                                onClick={() => handleDelete(index)}
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    </div>
                </div>

                <div className="flex items-center justify-between mt-2 text-gray-600 text-sm gap-4">
                  <div>
                    Showing {startEntry + 1} to {endEntry} of {totalEntries} entries
                  </div>

                  <div className="flex items-center gap-2">
                    <button
                      className="px-2"
                      onClick={() => handlePageChange(1)}
                      disabled={currentPage === 1}
                    >
                      &lt;&lt;
                    </button>

                    <button
                      className="px-2"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      &lt;
                    </button>

                    {getPageNumbers().map((pageNum) => (
                      <button
                        key={pageNum}
                        className={`px-3 py-1 mx-1 ${
                          currentPage === pageNum
                            ? "bg-blue-500 text-black"
                            : "bg-white text-gray-600"
                        } borderform rounded`}
                        onClick={() => handlePageChange(pageNum)}
                      >
                        {pageNum}
                      </button>
                    ))}

                    <button
                      className="px-2"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      &gt;
                    </button>

                    <button
                      className="px-2"
                      onClick={() => handlePageChange(totalPages)}
                      disabled={currentPage === totalPages}
                    >
                      &gt;&gt;
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
